import { useAuth } from '../../../../services/authentication/authContext';
import { canUseSuperAdminFeatures } from '../../../../services/accessManagement/accessManagement';
import { useAppUserDefaultStore, isAllRestaurantsSelected } from '../../../../stores/appUserDefaultStore';

/**
 * Who is looking at the Analysis page and for which restaurant selection.
 * `restaurantSelection` is the restaurant id or ALL_RESTAURANTS_ID (the action-item key).
 * Only a super admin identity sees the overviews + selection controls in v1.
 */
export function useAnalysisSelection() {
  const { backendUser } = useAuth();
  const restaurant = useAppUserDefaultStore(s => s.restaurant);
  return {
    restaurantSelection: restaurant?.id ?? '',
    isAllRestaurants: isAllRestaurantsSelected(restaurant),
    isSuperAdmin: canUseSuperAdminFeatures(backendUser),
  };
}
